import { Controller, SubmitHandler, useFormContext } from 'react-hook-form';
import {
  PrimaryButton, PrimaryTextField, ErrorMessage,
} from 'components';
import logo from 'assets/images/slocoach-logo.svg';
import { Link, Typography } from '@mui/material';
import { IResetTempPasswordForm } from 'base/auth/interface';

interface Props {
  onSubmit: SubmitHandler<any>;
}

const ResetTempPasswordFormView = (props: Props) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useFormContext<IResetTempPasswordForm>();
  const { onSubmit } = props;
  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ textAlign: 'left' }}>
      <Controller
        control={control}
        name="password"
        render={() => <div />}
      />
      <ErrorMessage>{errors?.password?.message}</ErrorMessage>
      <Controller
        control={control}
        name="name"
        render={() => <div />}
      />
      <ErrorMessage>{errors?.name?.message}</ErrorMessage>
      <div className="form-item">
        <Controller
          control={control}
          name="newPassword"
          render={({ field }) => <PrimaryTextField {...field} label="Password" isPassword />}
        />
        <ErrorMessage>{errors?.newPassword?.message}</ErrorMessage>
      </div>
      <div className="form-item">
        <Controller
          control={control}
          name="confirmPassword"
          render={({ field }) => (
            <PrimaryTextField {...field} label="Confirm password" isPassword />
          )}
        />
        <ErrorMessage>{errors?.confirmPassword?.message}</ErrorMessage>
      </div>
      <div className="form-item">
        <PrimaryButton size="large" fullWidth type="submit">
          Set password and get started
        </PrimaryButton>
      </div>
      <div className="text-center">
        <div className="mb-4 pb-2">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>Need help?</Typography>
          <Link href="mailto:help@slocoach.com" target="_blank" underline="none" variant="body2" sx={{ color: 'text.primary' }}>
            Contact us
          </Link>
        </div>
        <img src={logo} alt="Slo-Coach" />
      </div>
    </form>
  );
};

export default ResetTempPasswordFormView;
